import { render } from "./PattyPanel.vue?vue&type=template&id=05f2aa7b&scoped=true"
import script from "./PattyPanel.vue?vue&type=script&lang=js"
export * from "./PattyPanel.vue?vue&type=script&lang=js"

import "./PattyPanel.vue?vue&type=style&index=0&id=05f2aa7b&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f2aa7b"]])

export default __exports__